<template>
    <v-select
        ref="managers"
        :items="managers"
        :item-text="(item) => `${item.first_name} ${item.last_name}`"
        :item-value="(item) => item"
        :value="value"
        @input="$emit('input', $event)"
        label="經手人"
        placeholder="請選擇..."
    ></v-select>
</template>

<script>
import { managers } from '@/api'

export default {
    props: {
        value: {
            type: Object,
            default:() => {}
        }
    },
    data() {
        return {
            managers: []
        }
    },
    mounted() {
        managers.get().then(response => this.managers = response.data)
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ManagerSelect.vue